import * as types from 'models/actionTypes'
import { FURNITURE_ITEM } from 'constants/renderItemTypes'
import { TRACKING_ADDED_FROM_SALES_DRESSING, SALES_DRESSING } from 'models/tracking/constants'
import {
    getNextRenderItemId,
    getSelectedCompositionProductData,
    getSelectedCompositionId,
    getNextStackableInfo,
    getSwappingSurfaces,
    getSelectedRenderItem,
    getSelectedComposition,
    getSelectedCompositionMissingFurnitureIds,
    getSelectedCompositionData,
    getSelectedScene,
    getActiveSceneId,
    getSelectedCompositionRenderedFurnitureItem,
    getSelectedRenderItemId,
} from 'models/compositions/selectors'
import { getFurnitureIsLoadingByIds, getSelectedFurnitureSwappableItemsData } from 'models/furniture/selectors'
import { getDesignSidepanelMode } from 'models/ui/selectors'
import { getRenderer } from 'models/refStore/selectors'
import { getIsFetching as getScenesIsFetching } from 'models/scenes/selectors'
import {
    placeRenderItem,
    selectComposition,
    selectCompositionRenderItem,
    startPlaceStackableItem,
    clickPlaceStackableItem,
    swapStackableSurface,
    requestCompiledComposition,
    clickPlaceRenderItem,
    swapStackableToFloor,
    saveSelectedComposition,
    deleteCompositionRenderItem,
} from 'models/compositions/actions'
import { fetchScene } from 'models/scenes/actions'
import {
    setDesignSidepanelMode,
    showSwapMenuForId,
    openDesignSidepanel,
    closeDesignSidepanel,
    showMissingWallsModal,
} from 'models/ui/actions'
import {
    selectFurniture,
    requestFurnitureByIds,
    requestFurnitureCombinables,
    filterFeaturedProducts,
    clearFurnitureFilter,
} from 'models/furniture/actions'
import { showPlaceableSurfaces, hidePlaceableSurfaces } from 'models/preview/actions'
import * as modes from 'models/ui/constants'
import isMobile from 'utils/isMobile'
import { getSaveOnFirstRender } from 'models/location/selectors'
import { getProductTrackingInfo } from 'models/tracking/utils'

const compositionsMiddleware = (store) => (next) => (action) => {
    const state = store.getState()
    switch (action.type) {
        case types.PLACE_RENDER_ITEM: {
            store.dispatch(hidePlaceableSurfaces())
            const uniqueId = action.settings.uniqueId || getNextRenderItemId(state)
            return next({
                ...action,
                uniqueId,
            })
        }
        case types.CLICK_PLACE_RENDER_ITEM: {
            const renderer = getRenderer()
            if (renderer) {
                let newPos
                if (action.settings.renderType === FURNITURE_ITEM) {
                    newPos = renderer.findPlaceableFloorPos()
                } else {
                    newPos = renderer.findPlaceableWallPos()
                    if (!newPos) {
                        store.dispatch(showMissingWallsModal())
                        return next(action)
                    }
                }

                if (action.settings.stacks && !action.settings.onFloor) {
                    store.dispatch(selectCompositionRenderItem(-1))
                    const { settings, id } = action
                    store.dispatch(
                        startPlaceStackableItem(
                            {
                                ...settings,
                                id,
                            },
                            action.trackingInfo,
                        ),
                    )
                } else {
                    store.dispatch(
                        placeRenderItem(
                            action.compositionId,
                            action.id,
                            newPos[0],
                            newPos[1],
                            {
                                ...action.settings,
                                uniqueId: Math.floor(Date.now() / 2), // TODO This is not the best way to do this
                            },
                            action.trackingInfo,
                        ),
                    )
                }
            }
            return next(action)
        }
        case types.RENDER_ITEM_LOADED: {
            const { renderItems } = getSelectedComposition(state)
            const renderItem = renderItems.find((item) => item.uniqueId === action.id)
            if (renderItem) {
                if (
                    renderItem.metadata &&
                    renderItem.metadata.combinables &&
                    renderItem.metadata.combinables.nodesMeta
                ) {
                    renderItem.metadata.combinables.nodesMeta.forEach((nodeMeta, index) => {
                        /*
                        if (nodeMeta.items && nodeMeta.items.length > 0) {
                            const productTrackingInfo = getProductTrackingInfo(renderItem)
                            const trackingInfo = {
                                ...productTrackingInfo,
                                AddedFrom: TRACKING_ADDED_FROM_SALES_DRESSING,
                            }
                            const settings = {
                                renderType: FURNITURE_ITEM,
                                heading: 0,
                                stacks: false,
                                hidden: renderItem.hidden,
                                combinablePlacement: {
                                    parentId: action.id,
                                    localTransform: nodeMeta.matrixModel.flat(),
                                }
                            }
                            store.dispatch(
                                placeRenderItem(
                                    compositionId,
                                    renderItem.id,
                                    0,
                                    0,
                                    settings,
                                    combinablePlacement,
                                    trackingInfo,
                                ),
                            )
                        } else {
*/
                        // look for nearest non-wildcard variant in all ancestors
                        const wildcardVariant = 2 // probably temporary
                        let currParentRenderItem = renderItem
                        let variant = currParentRenderItem.metadata.combinables.selfMeta.variant || wildcardVariant
                        while (variant === wildcardVariant) {
                            const parentUniqueId =
                                currParentRenderItem.combinablePlacement &&
                                currParentRenderItem.combinablePlacement.parentId
                            if (!parentUniqueId) {
                                break
                            }
                            currParentRenderItem = renderItems.find((item) => item.uniqueId === parentUniqueId)
                            if (!currParentRenderItem) {
                                break
                            }
                            variant = currParentRenderItem.metadata.combinables.selfMeta.variant || wildcardVariant
                        }

                        const slotCategory = nodeMeta.category
                        const size = nodeMeta.size
                        store.dispatch(
                            requestFurnitureCombinables(
                                renderItem.id,
                                renderItem.uniqueId,
                                slotCategory,
                                size,
                                variant,
                                index,
                            ),
                        )
                        //                        }
                    })
                }
            }
            return next(action)
        }
        case types.START_PLACE_STACKABLE_ITEM: {
            const { stackableSurfaces } = getSelectedComposition(state)
            const surfaces = stackableSurfaces.map((surface) => surface.id)
            store.dispatch(showPlaceableSurfaces(surfaces))
            return next(action)
        }
        case types.START_SWAP_STACKABLE_SURFACE: {
            const { stackableSurfaces } = getSelectedComposition(state)
            const surfaces = stackableSurfaces.map((surface) => surface.id)
            store.dispatch(showPlaceableSurfaces(surfaces))
            return next(action)
        }
        case types.STACKABLE_SURFACE_CLICKED: {
            const isSwappingSurfaces = getSwappingSurfaces(state)
            if (isSwappingSurfaces) {
                store.dispatch(hidePlaceableSurfaces())
                const compositionId = getSelectedCompositionId(state)
                const itemId = getSelectedRenderItem(state).uniqueId
                store.dispatch(swapStackableSurface(compositionId, itemId, action.planeId, action.x, action.y))
            } else {
                store.dispatch(clickPlaceStackableItem(action.planeId, action.x, action.y))
            }
            return next(action)
        }
        case types.CLICK_PLACE_STACKABLE_ON_FLOOR: {
            const isSwapping = getSwappingSurfaces(state)

            const compId = getSelectedCompositionId(state)

            if (!isSwapping) {
                const info = getNextStackableInfo(state)

                const settings = {
                    renderType: info.settings.renderType,
                    heading: info.settings.heading,
                    onFloor: true,
                }

                store.dispatch(clickPlaceRenderItem(compId, info.settings.id, settings, info.trackingInfo))
            } else {
                store.dispatch(hidePlaceableSurfaces())

                const renderer = getRenderer()

                if (renderer) {
                    const selected = getSelectedRenderItem(state)
                    const newPos = renderer.findPlaceableFloorPos()

                    store.dispatch(swapStackableToFloor(compId, selected.uniqueId, newPos[0], newPos[1]))
                }
            }

            return next(action)
        }
        case types.CLICK_PLACE_STACKABLE_ITEM: {
            const nextStackableInfo = getNextStackableInfo(state)
            const compositionId = getSelectedCompositionId(state)
            const { trackingInfo, settings } = nextStackableInfo
            settings.stackedPlane = action.planeId
            store.dispatch(placeRenderItem(compositionId, settings.id, action.x, action.y, settings, trackingInfo))
            return next(action)
        }
        case types.OPEN_COMPOSITION: {
            const mode = getDesignSidepanelMode(state)
            const isShowingCatalog =
                mode === modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE ||
                mode === modes.DESIGN_SIDEPANEL_MODE_PRODUCT_DETAILS

            // Redirect to product browse if the user was previously on my items
            const isShowingMyItems =
                mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE ||
                mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS
            const isShowingSwap =
                mode === modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE || modes.DESIGN_SIDEPANEL_MODE_SWAP_DETAILS

            // When entering a new composition, clear out the furniture filter
            if (isShowingCatalog) {
                store.dispatch(clearFurnitureFilter())
            }
            // Hide the swap menu on opening a composition if it was previously open
            if (isShowingSwap) {
                store.dispatch(showSwapMenuForId(false))
            }
            if (isShowingMyItems || isShowingSwap) {
                store.dispatch(setDesignSidepanelMode(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE))
            }
            store.dispatch(selectComposition(action.compositionId, action.trackingInfo))
            return next(action)
        }
        case types.DELETE_COMPOSITION_RENDER_ITEM: {
            const { renderItems } = getSelectedComposition(state)
            const renderedItems = getSelectedCompositionProductData(state)

            const renderItem = renderItems.find((item) => item.uniqueId === action.id)
            const isCombinableChild = !!renderItem.combinablePlacement

            if (!isCombinableChild) {
                const mode = getDesignSidepanelMode(state)
                // Hide the swap menu on deleting an item
                store.dispatch(showSwapMenuForId(false))

                // If there are no my items, redirect to product browse
                const isShowingMyItems =
                    mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE ||
                    mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS
                if (isShowingMyItems) {
                    // renderItems.length will be one if this item is going to be deleted
                    if (renderedItems.length === 1) {
                        store.dispatch(setDesignSidepanelMode(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE))
                    } else {
                        store.dispatch(setDesignSidepanelMode(modes.DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE))
                    }
                } else {
                    store.dispatch(setDesignSidepanelMode(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE))
                }
            }

            // delete all combinable children of this item, if any
            const combinableChildren = renderItems.filter(
                (item) => item.combinablePlacement && item.combinablePlacement.parentId === action.id,
            )
            if (combinableChildren.length > 0) {
                const compositionId = getSelectedCompositionId(state)
                combinableChildren.forEach((item) => {
                    const productData = renderedItems.find((prod) => prod.uniqueId === item.uniqueId)
                    const productTrackingInfo = getProductTrackingInfo(productData)
                    const trackingInfo = {
                        ...productTrackingInfo,
                        RemovedFrom: SALES_DRESSING,
                    }
                    store.dispatch(deleteCompositionRenderItem(compositionId, item.uniqueId, trackingInfo))
                })
            }

            return next({ ...action, isLastItem: renderedItems.length === 1 })
        }
        case types.SELECT_COMPOSITION_RENDER_ITEM: {
            const result = next(action)
            const nextState = store.getState()
            const { renderItemId } = action

            const mode = getDesignSidepanelMode(state)
            const isShowingMyItemDetails = mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS
            const isShowingSwap =
                mode === modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE || modes.DESIGN_SIDEPANEL_MODE_SWAP_DETAILS

            if (renderItemId === -1) {
                store.dispatch(showSwapMenuForId(false))

                // Redirect to product browse when a selected rendered item is cleared
                if (isShowingMyItemDetails || isShowingSwap) {
                    store.dispatch(setDesignSidepanelMode(modes.DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE))
                }
            } else {
                const { id } = getSelectedRenderItem(nextState)
                store.dispatch(showSwapMenuForId(true, id))
                store.dispatch(setDesignSidepanelMode(modes.DESIGN_SIDEPANEL_MODE_SWAP_BROWSE))
                if (isMobile()) {
                    store.dispatch(openDesignSidepanel())
                }
            }
            store.dispatch(hidePlaceableSurfaces())
            return result
        }
        case '@@router/LOCATION_CHANGE':
        case types.TRIGGER_COMPOSITION_LOAD:
        case types.RECEIVE_USER:
        case types.RECEIVE_COMPOSITIONS:
        case types.RECEIVE_SCENES:
        case types.RECEIVE_SCENE:
        case types.SET_COMPOSITION_PRE_FETCH_LOADING:
        case types.RECEIVE_COMPILED_COMPOSITION:
        case types.SELECT_COMPOSITION: {
            const result = next(action)
            const nextState = store.getState()

            // If we don't have the composition, load it
            const selectedCompositionData = getSelectedCompositionData(nextState)
            if (!selectedCompositionData) {
                const selectedCompositionId = getSelectedCompositionId(nextState)
                store.dispatch(requestCompiledComposition(selectedCompositionId))
            } else if (!getScenesIsFetching(nextState)) {
                // If we have a comp, but not the scene, load it
                const selectedScene = getSelectedScene(nextState)
                if (!selectedScene) {
                    const activeSceneId = getActiveSceneId(nextState)
                    if (activeSceneId) {
                        store.dispatch(fetchScene(activeSceneId))
                    }
                }
            }

            // Load furniture items we're missing
            if (!getFurnitureIsLoadingByIds(nextState)) {
                const missingFurnitureIds = getSelectedCompositionMissingFurnitureIds(nextState)
                if (missingFurnitureIds.length) {
                    store.dispatch(requestFurnitureByIds(missingFurnitureIds))
                }
            }

            if (
                action.type === types.RECEIVE_SCENE ||
                action.type === types.RECEIVE_SCENES ||
                action.type === types.RECEIVE_COMPILED_COMPOSITION
            ) {
                // If we're receiving scenes, try to enable featured products
                store.dispatch(filterFeaturedProducts())
            }

            return result
        }
        case types.SWAP_RENDER_ITEM: {
            // delete all combinable children of this item, if any
            const renderedItems = getSelectedCompositionProductData(state)
            const { renderItems } = getSelectedComposition(state)
            const combinableChildren = renderItems.filter(
                (item) => item.combinablePlacement && item.combinablePlacement.parentId === action.targetRenderItemId,
            )
            if (combinableChildren.length > 0) {
                const compositionId = getSelectedCompositionId(state)
                combinableChildren.forEach((item) => {
                    const productData = renderedItems.find((prod) => prod.uniqueId === item.uniqueId)
                    const trackingInfo = {
                        ProductTitle: productData.name,
                        ProductId: productData.id,
                        ProductSource: productData.source,
                        RemovedFrom: SALES_DRESSING,
                    }
                    store.dispatch(deleteCompositionRenderItem(compositionId, item.uniqueId, trackingInfo))
                })
            }

            if (isMobile()) {
                store.dispatch(closeDesignSidepanel())
            } else {
                store.dispatch(selectFurniture(action.productId))
            }
            const uniqueId = getNextRenderItemId(state)
            const compositionId = getSelectedCompositionId(state)
            return next({
                compositionId,
                uniqueId,
                ...action,
            })
        }
        case types.DUPLICATE_RENDER_ITEM: {
            const { targetRenderItemId, renderType, trackingInfo } = action

            const selectedCompositionData = getSelectedCompositionData(state)
            const targetRenderItem = selectedCompositionData.renderItems[targetRenderItemId]
            const uniqueId = getNextRenderItemId(state)
            const compositionId = getSelectedCompositionId(state)
            const settings = {
                ...targetRenderItem,
                uniqueId,
                renderType,
            }

            if (settings.stackedPlane) {
                delete settings.stackedPlane
                settings.stacks = true
            }

            delete settings.x
            delete settings.y
            delete settings.metrics
            delete settings.readyAndRendered

            store.dispatch(clickPlaceRenderItem(compositionId, targetRenderItem.id, settings, trackingInfo))

            return next(action)
        }
        case types.RECEIVE_FURNITURE_COMBINABLES: {
            if (action.furniture.length === 0) {
                return next(action)
            }
            const compositionId = getSelectedCompositionId(state)
            const parentFurnitureData = getSelectedCompositionProductData(state).find(
                (item) => item.uniqueId === action.parentUniqueId,
            )
            if (parentFurnitureData) {
                const furniture = action.furniture[0]
                const productTrackingInfo = getProductTrackingInfo(furniture)
                const trackingInfo = {
                    ...productTrackingInfo,
                    AddedFrom: TRACKING_ADDED_FROM_SALES_DRESSING,
                }
                const settings = {
                    renderType: FURNITURE_ITEM,
                    heading: 0,
                    stacks: false,
                    hidden: furniture.hidden,
                    combinablePlacement: {
                        parentId: action.parentUniqueId,
                        localTransform:
                            parentFurnitureData.metadata.combinables.nodesMeta[action.nodeIndex].matrixModel.flat(),
                    },
                }
                store.dispatch(placeRenderItem(compositionId, furniture.id, 0, 0, settings, trackingInfo))
            }
            return next(action)
        }
        case types.SET_INITIAL_LOADING: {
            const nextState = next(action)
            if (!action.initialLoading && getSaveOnFirstRender(state)) {
                store.dispatch(saveSelectedComposition())
            }
            return nextState
        }
        case types.START_TEST_SWAP_SAGA: {
            const swapItemsData = getSelectedFurnitureSwappableItemsData(state)
            const selectedProduct = getSelectedCompositionRenderedFurnitureItem(state)
            const targetRenderItemId = getSelectedRenderItemId(state)
            return next({
                ...action,
                targetRenderItemId,
                selectedProduct,
                swapItemsData,
            })
        }
        case types.TEST_SWAP_SAGA_FINISHED: {
            /* eslint-disable no-console */
            console.group('After multi swap test heap difference:')
            console.log(`jsHeapSizeLimitDelta: ${action.results.jsHeapSizeLimitDelta / 1024 / 1024}Mb`)
            console.log(`totalJSHeapSizeDelta: ${action.results.totalJSHeapSizeDelta / 1024 / 1024}Mb`)
            console.log(`usedJSHeapSizeDelta: ${action.results.usedJSHeapSizeDelta / 1024 / 1024}Mb`)
            console.log(`textureMemoryDelta: ${action.results.textureMemoryDelta / 1024 / 1024}Mb`)
            console.log(`bufferMemoryDelta: ${action.results.bufferMemoryDelta / 1024 / 1024}Mb`)
            console.groupEnd()
            return next(action)
        }
        case types.TEST_LOAD_SAGA_FINISHED: {
            /* eslint-disable no-console */
            console.group('After multi load/delete test heap difference:')
            console.log(`jsHeapSizeLimitDelta: ${action.results.jsHeapSizeLimitDelta / 1024 / 1024}Mb`)
            console.log(`totalJSHeapSizeDelta: ${action.results.totalJSHeapSizeDelta / 1024 / 1024}Mb`)
            console.log(`usedJSHeapSizeDelta: ${action.results.usedJSHeapSizeDelta / 1024 / 1024}Mb`)
            console.log(`textureMemoryDelta: ${action.results.textureMemoryDelta / 1024 / 1024}Mb`)
            console.log(`bufferMemoryDelta: ${action.results.bufferMemoryDelta / 1024 / 1024}Mb`)
            console.groupEnd()
            return next(action)
        }
        case types.UPDATE_HIDDEN_SURFACES: {
            const result = next(action)
            const newState = store.getState()

            const composition = getSelectedCompositionData(newState)
            const { hiddenSurfaces } = composition

            const droppedRenderItems = Object.values(composition.renderItems).filter((renderItem) =>
                hiddenSurfaces.includes(renderItem.stackedPlane),
            )

            const renderer = getRenderer()
            const compositionId = getSelectedCompositionId(newState)

            droppedRenderItems.forEach((renderItem) => {
                const renderItemUniqueId = renderItem.uniqueId
                const newPos = renderer.findPlaceableFloorPos()
                store.dispatch(swapStackableToFloor(compositionId, renderItemUniqueId, newPos[0], newPos[1]))
            })

            return result
        }
        default:
            return next(action)
    }
}

export default compositionsMiddleware
